module.exports = __webpack_public_path__ + "444a7284663a3bc886683eb81450b294.woff2";